import { createSlice } from '@reduxjs/toolkit';

const name = 'inboxCount';

const initialState = {
    allCount : {}
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setAllCount(state, action) {
            state.allCount = action.payload;
        },
    }
});

export const {setAllCount} = slice.actions;

export const { reducer } = slice;

export const selectAllCount = (state) => state[name].allCount;

const inboxCountReducer = reducer;
export default inboxCountReducer;
